let ufoAlert = {
    $el: $('#js-ufoAlert'),
    $city: $('#js-ufoAlertCity'),
    $cityForm: $('#js-ufoAlertCityForm'),
    $cityReset: $('#js-ufoAlertCityReset'),
    $citySelected: $('#js-ufoAlertCitySelected'),
    $citySelectedLabel: $('#js-ufoAlertCitySelectedLabel'),
    $form: $('#js-ufoAlertForm'),
    $inputEmail: $('#js-ufoAlertInputEmail'),
    $inputCityName: $('#js-ufoAlertInputCityName'),
    $inputProvinceName: $('#js-ufoAlertInputProvinceName'),
    $inputQuery: $('#js-ufoAlertInputQuery'),
    $modal: $('#js-modalUfoAlert'),
    $submit: $('#js-ufoAlertSubmit'),
    autocomplete: null,
    classNameComplete: 'is-complete',

    init() {
        this.$cityReset.on(app.eventNameClick, this.onCityReset.bind(this))
        this.$form.on('ajaxForm:success', this.onFormSuccess.bind(this))
        this.$modal.on('modal:open', this.onModalShow.bind(this))
    },

    initMap() {
        console.log('ufoAlert.initMap')

        this.autocomplete = new google.maps.places.Autocomplete(this.$inputQuery.get(0), {
            componentRestrictions: {'country': 'nl'},
            types: ['(cities)']
        })
        this.autocomplete.addListener('place_changed', this.onPlaceChanged.bind(this))
    },

    onCityReset(e) {
        this.resetCity()
        e.preventDefault()
    },

    onFormSuccess(e, data) {
        this.$city.text(data.city_name)
        this.$el.addClass(this.classNameComplete)
    },

    onModalShow() {
        let city
        let province

        // Reset previous alert
        this.reset()

        // Set predefined values
        city = this.$el.attr('data-city')
        province = this.$el.attr('data-province')

        if (city !== '' && province !== '') {
            this.setCity(city, province)
        }

        app.modules.googleMaps.load(this.initMap.bind(this))
    },

    onPlaceChanged() {
        let city
        let place
        let province

        place = this.autocomplete.getPlace()
        this.$inputCityName.val('')
        this.$inputProvinceName.val('')

        if (place) {
            city = _.find(place.address_components, o => o.types[0] === 'locality')
            province = _.find(place.address_components, o => o.types[0] === 'administrative_area_level_1')

            if (city.long_name && province.short_name) {
                this.setCity(city.long_name, province.short_name)
            }
        }
    },

    reset() {
        this.$el.removeClass(this.classNameComplete)
        this.$inputQuery.focus()
        this.resetCity()
    },

    resetCity() {
        this.$cityForm.show()
        this.$citySelectedLabel.text('')
        this.$citySelected.hide()
        this.$inputCityName.val('')
        this.$inputProvinceName.val('')
        this.$inputQuery.focus()
        this.$submit.prop('disabled', true)
    },

    setCity(city, province) {
        this.$inputQuery.val('')
        this.$cityForm.hide()
        this.$citySelectedLabel.text(`${city}, ${province}`)
        this.$citySelected.show()
        this.$inputCityName.val(city)
        this.$inputProvinceName.val(province)
        this.$submit.prop('disabled', false)
        this.$inputEmail.focus()
    }
}

export default ufoAlert